import { useState } from "react";
import { useLocation } from "react-router-dom";
import AppShell from "@/components/AppShell";
import { useAuth } from "@/context/AuthContext";
import { adminTabsFor } from "@/lib/roles";
import OverviewTab from "@/components/admin/OverviewTab";
import UsersTab from "@/components/admin/UsersTab";
import SubscriptionsTab from "@/components/admin/SubscriptionsTab";
import VerificationsTab from "@/components/admin/VerificationsTab";
import ApprovalQueueTab from "@/components/admin/ApprovalQueueTab";
import ComplianceTab from "@/components/admin/ComplianceTab";
import OnboardingTab from "@/components/admin/OnboardingTab";
import TrustScoresTab from "@/components/admin/TrustScoresTab";

const TAB_COMPONENTS = {
  "Overview": OverviewTab,
  "Users": UsersTab,
  "Subscriptions": SubscriptionsTab,
  "Onboarding": OnboardingTab,
  "Compliance": ComplianceTab,
  "Approval Queue": ApprovalQueueTab,
  "Verifications": VerificationsTab,
  "Trust Scores": TrustScoresTab,
};

export default function Admin() {
  const { user } = useAuth();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const tabParam = params.get("tab");            // e.g. "onboarding"
  const focusUserId = params.get("user") || null; // deep-link target from the signup alert
  const allowed = adminTabsFor(user?.role);
  const paramTabKey = tabParam ? allowed.find((k) => k.toLowerCase().replace(/\s/g, "-") === tabParam.toLowerCase()) : null;
  const [tab, setTab] = useState(paramTabKey || allowed[0] || "Overview");
  const activeKey = allowed.includes(tab) ? tab : (allowed[0] || "Overview");
  const Active = TAB_COMPONENTS[activeKey] || OverviewTab;

  return (
    <AppShell title="Admin Control Center" subtitle="Platform operations, revenue and trust monitoring.">
      <div className="flex gap-1 border-b border-slate-200 mb-6 overflow-x-auto" data-testid="admin-tabs">
        {allowed.map((key) => (
          <button key={key} onClick={() => setTab(key)} data-testid={`admin-tab-${key.toLowerCase().replace(/\s/g, "-")}`}
            className={`px-4 py-2.5 text-sm font-medium whitespace-nowrap border-b-2 -mb-px transition-colors ${activeKey === key ? "border-[#2563EB] text-[#0A0F1C]" : "border-transparent text-slate-500 hover:text-[#0A0F1C]"}`}>
            {key}
          </button>
        ))}
      </div>
      {activeKey === "Onboarding" ? <Active focusUserId={focusUserId} /> : <Active />}
    </AppShell>
  );
}
